import PortalIdParser from 'PortalIdParser';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import Associations from 'in-meeting-experience-ui-components/components/associations/Associations/Associations';
import { LEGACY_DEAL_AMOUNT_CALCULATION } from 'products-ui-components/constants/Scopes';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { routes } from '../constants/routes';
import { associateObject, fetchAssociationSectionList, getCreatorAssociationPropertiesDefinitions, removeAssociationObject, updateAssociationObject } from '../data/api/associationsApi';
import { getAvatars } from '../data/api/avatarsApi';
import { createCrmObject, createCrmObjectBatch, getObject, searchObject } from '../data/api/crmV3Api';
import { calculatedProperties, getDealAmountCalculationProperty, getHomeCurrency } from '../data/api/dealsApi';
import { fetchPlaybooks, fetchRecommendedPlaybooks } from '../data/api/playbooksApi';
import { fetchCardProperties, fetchExternalOptions, fetchObjectCreationFields, fetchPropertiesDetails, validateProperty } from '../data/api/propertiesApi';
import { fetchRenderedContent, fetchUnrenderedContent, searchSnippets } from '../data/api/snippetsApi';
import useTracker from '../hooks/useTracker';
import { hubspotUserIdSelector, prosemirrorTrackerPropertiesSelector, scopesSelector } from '../slices/auth/selectors';
import { callObjectIdSelector, callObjectTitleSelector } from '../slices/callObject/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
function AssociationsPage() {
  const callObjectId = useSelector(callObjectIdSelector);
  const callObjectTitle = useSelector(callObjectTitleSelector);
  const hubspotUserId = useSelector(hubspotUserIdSelector);
  const scopes = useSelector(scopesSelector);
  const prosemirrorTrackerProperties = useSelector(prosemirrorTrackerPropertiesSelector);
  const usageTracker = useTracker();
  const hasLegacyDealAmountCalculation = useMemo(() => scopes.includes(LEGACY_DEAL_AMOUNT_CALCULATION), [scopes]);
  if (!callObjectId) {
    return /*#__PURE__*/_jsx(LoadingOverlay, {
      contextual: true
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "ASSOCIATIONS_PAGE_LOADED",
    children: /*#__PURE__*/_jsx(Associations, {
      portalId: PortalIdParser.getPortalIdFromPath(),
      hubspotUserId: hubspotUserId,
      callObjectId: Number(callObjectId),
      callObjectTitle: callObjectTitle,
      featureTipsLink: "",
      usageTracker: usageTracker,
      apiWrapper: {
        snippets: {
          fetchRenderedContent,
          fetchUnrenderedContent,
          searchSnippets
        },
        playbooks: {
          fetchPlaybooks,
          fetchRecommendedPlaybooks
        },
        getObject,
        updateAssociationObject,
        fetchObjectCreationFields,
        fetchPropertiesDetails,
        createCrmObject,
        validateProperty,
        fetchExternalOptions,
        searchObject,
        fetchAssociationSectionList,
        associateObject,
        removeAssociationObject,
        fetchCardProperties,
        calculateProperties: calculatedProperties,
        getMultiCurrencies: getHomeCurrency,
        getDealAmountSettings: getDealAmountCalculationProperty,
        createCrmObjectBatch,
        getCreatorAssociationPropertiesDefinitions,
        getAvatars
      },
      hasLegacyDealAmountCalculation: hasLegacyDealAmountCalculation,
      prosemirrorTrackerProperties: prosemirrorTrackerProperties,
      reconnectRoute: routes.reconnect
    })
  });
}
export default AssociationsPage;